import { FC } from 'react'
import { GroupJoinMode } from '@wellesley/openapi'
import CommonDialog from 'components/modals/CommonDialog'
import { Button } from '@wellesley/ui'
import GroupRules from '../../GroupRules'
import useGroupRules from '../../../hooks/useGroupRules'
import ModalLoader from 'components/modals/ModalLoader'

type RulesModalProps = {
  open: boolean
  groupId: string
  onClose: () => void
  title?: string
  isLoading?: boolean
  joinMode?: GroupJoinMode
  inviteLink?: boolean
  onAgree?: (e: React.MouseEvent) => void
}

const RulesModal: FC<RulesModalProps> = ({
  open,
  groupId,
  onClose,
  onAgree,
  title = 'Group Rules',
  isLoading = false,
  joinMode = 'OPEN',
  inviteLink = false,
}) => {
  const { isLoading: isRulesLoading } = useGroupRules({ groupId })

  const getButtonText = () => {
    if (isLoading) return 'Loading...'
    if (joinMode === 'OPEN' || (joinMode === 'INVITE_ONLY' && inviteLink)) {
      return 'Agree and join'
    }
    return 'Agree and request'
  }

  return (
    <CommonDialog
      open={open}
      title={title}
      onCloseModal={onClose}
      titleClassName="!border-none"
      className="max-w-[450px]"
      childrenClassName="!p-0 min-h-[300px]"
      renderFooter={() =>
        onAgree ? (
          <Button
            variant="primary"
            size="m"
            className="w-full"
            onClick={(e) => onAgree?.(e)}
            disabled={isLoading}
            dataTestId="rules-submit-button"
          >
            {getButtonText()}
          </Button>
        ) : null
      }
    >
      {isRulesLoading ? <ModalLoader /> : <GroupRules />}
    </CommonDialog>
  )
}

export default RulesModal
